import { includes } from 'lodash'

export default function firstSource(contentType='', sources) {
  const availableSources = sources.filter((s) => s.available === true)
  const filteredSources = availableSources.filter((s) => includes(s.label, contentType) && !includes(s.label, 'm3u8'))
  return filteredSources[0]
}
